/**
 * Tag của DS trong vùng bấm cao 44px (touch target tối thiểu) — Tag gốc chỉ cao ~30px.
 * Giữ nguyên style Tag (ds/Tag.tsx); vùng đệm trong suốt nằm trên/dưới viên thuốc.
 */
export function Chip({ label, active, onClick }: { label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      style={{ minHeight: 44, padding: 0, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', flexShrink: 0 }}
    >
      <span
        className={active ? undefined : 'sk-press-page'}
        style={{
          fontFamily: 'var(--font-vi)',
          fontSize: 13,
          fontWeight: 500,
          padding: '6px 14px',
          borderRadius: 'var(--radius-pill)',
          border: active ? '1px solid var(--cta-default)' : '1px solid var(--border-default)',
          color: active ? '#fff' : 'var(--ink)',
          whiteSpace: 'nowrap',
          ...(active ? { background: 'var(--navy-500)' } : {}),
        }}
      >
        {label}
      </span>
    </button>
  );
}
